import wixWindow from 'wix-window';
let formFactor = wixWindow.formFactor; // "Mobile"

export function footer1_mouseIn(event) {
	if (formFactor !== "Mobile") {
		// $w("#chep1Reg").show()
		// $w("#chep1Hover").hide()
		// $w("#chep2Reg").show()
		// $w("#chep2Hover").hide()
		// $w("#chep3Reg").show()
		// $w("#chep3Hover").hide()
		// $w("#chep4Reg").show()
		// $w("#chep4Hover").hide()
		// $w("#chep5Reg").show()
		// $w("#chep5Hover").hide()
	}
}

export function HeaderReg_mouseIn(event) {
	if (formFactor !== "Mobile") {

		// $w("#HeaderReg").hide()
		// $w("#HeaderHover").show()
	}
}

export function HeaderHover_mouseOut(event) {
	if (formFactor !== "Mobile") {

		$w("#HeaderReg").show()
		// $w("#HeaderHover").hide()
	}
}

// export function header1_mouseIn(event) {
// 	if (formFactor !== "Mobile") {

// 		$w("#HeaderReg").show()
// 		$w("#HeaderHover").hide()
// 	}
// }